import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from 'app/main/services/roles.service';
import {TranslateService} from '@ngx-translate/core';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import { TipoDocumentoService } from 'app/main/services/tipo-documento.service';
import { TipoDocumento } from 'app/main/models/tipo-documento.model';
import { PaisService } from 'app/main/services/pais.service';
import { Contacto } from 'app/main/models/contacto.model';
import { Usuario } from 'app/main/models/usuario.model';
import { UsersService } from 'app/main/services/users.service';
import { Telefono } from 'app/main/models/telefono.model';
import { DocumentoDeIdentidad } from 'app/main/models/documento-de-identidad.model';
import { PersonaFisica } from 'app/main/models/persona-fisica.model';
import { Accionista } from 'app/main/models/accionista.model';


@Component({
  selector: 'accionista-dialog-box',
  templateUrl: './dialog-accionista-box.component.html',
  styleUrls: ['./dialog-accionista-box.component.scss']
})
export class AccionistaDialogBoxComponent {

  accionista: PersonaFisica;
  action: string;
  LOCAL_DATA: any;
  GENERAL_DATA: Telefono;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  tiposDocumentos = [];
  tiposSujetos = [];
  tiposSectorIndustrial = [];
  tiposProfesiones = [];
  paises = [];
  
  constructor(
    private roleService: RoleService,
    public dialogRef: MatDialogRef<AccionistaDialogBoxComponent>,
    public translate: TranslateService,
    private serviceTipoDocumento: TipoDocumentoService,
    private servicePais: PaisService,
    private serviceUsuario: UsersService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Accionista) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
    delete this.LOCAL_DATA['action'];
    if(this.LOCAL_DATA==null || Object.keys(this.LOCAL_DATA).length==0){
      this.LOCAL_DATA = new Usuario({});
      this.LOCAL_DATA.contacto = new Contacto({});
      var telefono = new Telefono({});
      this.LOCAL_DATA.contacto.telefonos.push(telefono);
      this.LOCAL_DATA.documentoIdentidad = new DocumentoDeIdentidad({});
    }
  }

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  doAction(): void{
    
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {
    this.serviceTipoDocumento.getList().pipe().subscribe(req => {
      this.tiposDocumentos = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre,
          tipo: tipo.tipo
        };
      });
    });

      this.servicePais.getList().pipe().subscribe(req => {
        this.paises = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
    });

  }

  validarPorcentajeAccionario() {
    if (this.LOCAL_DATA.porcentajeAccionario < 0)
      this.LOCAL_DATA.porcentajeAccionario = 0;
    if(this.LOCAL_DATA.porcentajeAccionario > 100)
      this.LOCAL_DATA.porcentajeAccionario = 100;
  }
  
  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }

  openDialog(): void {}

}
